import { useState, type ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { useLogout } from "../features/auth/hooks";
import { Logo } from "./Logo";
import {
  BarChart3Icon,
  HistoryIcon,
  LogOutIcon,
  MoreHorizontalIcon,
  ShoppingBagIcon,
  UsersIcon,
} from "./icons";

const navItems = [
  { to: "/", label: "Venta", icon: ShoppingBagIcon, end: true },
  { to: "/sales", label: "Historial", icon: HistoryIcon, end: false },
  { to: "/customers", label: "Clientes", icon: UsersIcon, end: false },
  { to: "/summary", label: "Resumen", icon: BarChart3Icon, end: false },
  { to: "/more", label: "Más", icon: MoreHorizontalIcon, end: false },
] as const;

export function AppShell({ operatorName, children }: { operatorName: string; children: ReactNode }) {
  const [userOpen, setUserOpen] = useState(false);
  const logout = useLogout();

  return (
    <div className="app-shell">
      <header className="app-topbar">
        <NavLink to="/" className="brand-lockup" aria-label="Ir a Venta">
          <Logo height={22} decorative />
          <small>Punto de venta</small>
        </NavLink>

        <nav className="desktop-nav" aria-label="Navegación principal">
          {navItems.slice(0, 4).map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} className={({ isActive }) => `desktop-nav__item${isActive ? " is-active" : ""}`}>
              <Icon width={18} height={18} />
              {label}
            </NavLink>
          ))}
          <NavLink to="/more" className={({ isActive }) => `desktop-nav__item${isActive ? " is-active" : ""}`}>
            <MoreHorizontalIcon width={18} height={18} />
            Más
          </NavLink>
        </nav>

        <div className="user-menu">
          <button className="user-menu__trigger" type="button" onClick={() => setUserOpen((value) => !value)} aria-expanded={userOpen}>
            <span className="user-menu__avatar">{operatorName.trim().charAt(0).toUpperCase() || "?"}</span>
            <span className="user-menu__name">{operatorName}</span>
          </button>
          {userOpen && (
            <>
              <button className="menu-scrim" type="button" aria-label="Cerrar menú" onClick={() => setUserOpen(false)} />
              <div className="user-menu__popover">
                <span>Sesión de {operatorName}</span>
                <button type="button" onClick={() => logout.mutate()} disabled={logout.isPending}>
                  <LogOutIcon /> {logout.isPending ? "Saliendo…" : "Cerrar sesión"}
                </button>
              </div>
            </>
          )}
        </div>
      </header>

      <div className="app-content">{children}</div>

      <nav className="mobile-bottom-nav" aria-label="Navegación principal">
        {navItems.map(({ to, label, icon: Icon, end }) => (
          <NavLink key={to} to={to} end={end} className={({ isActive }) => `mobile-bottom-nav__item${isActive ? " is-active" : ""}`}>
            <Icon width={21} height={21} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
